import React from 'react';
import { Carousel, Container } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import book from "../../images/book-store-1.PNG";
import jamuna from "../../images/hpJamuna.PNG";
import red from "../../images/hpRed.PNG";
import word from "../../images/wordHome2.PNG";
import crypto from "../../images/homeCrypto.PNG";
const HomeProjects = () => {
    const Data = [
        {
            title: 'RealXstate',      
            description: 'A beautiful Real Estate  Next js Application: search property by your choice: filtering option; to buy or rent . . .',
            github: 'https://github.com/rajonahmed749/real-state-website',
            live: 'https://real-state-website-pi.vercel.app/',
            techStack: ['Next js', 'Chakra UI', 'Rapid API']
        },
        {
            title: 'News App',
            description: 'A React Native News app, you can view the latest news, search and filter them from popular news like BBC News, CNN, FOX News etc.',
            github: 'https://github.com/rajonahmed749/news-app',
            live: 'https://expo.dev/@rajon_ahmed/news-today',
            techStack: ['React Native', 'Expo', 'Rest API']
        },
        {
            title: 'Planet App',
            description: 'A stunning user interface for viewing and searching planets. Mainly focues on UI design in React Native. Click and view the project',
            github: 'https://github.com/rajonahmed749/planet-app',
            live: 'https://expo.dev/@rajon_ahmed/planet-app',
            techStack: ['React Native', 'Expo', 'Figma']
        },
    ]
    return (
        <Container className="my-5">
            <h3 className="textColor text-center my-5"><span className="fs-2 border-bottom border-info"> My Projects </span></h3>
            <div className="row justify-content-center project-row">
                {
                    Data.map((p) => {
                        return (
                            <div className="col-md-3 col-sm-12">
                                <Card className='shadow' style={{ backgroundColor: '#112240', marginBottom: '10px' }}>
                                    <Card.Body>
                                        <div className='d-flex justify-content-end'>
                                            <a href={p.github} target='_blank' title='Github'>
                                                <i style={{ color: 'white' }} className="fab fa-github  mx-3 icon"></i>
                                            </a>
                                            <a href={p.live} target='_blank' title='Live Link'>
                                                <i style={{ color: 'white' }} className="fas fa-external-link-alt icon"></i>
                                            </a>
                                        </div>

                                        <Card.Title style={{ color: '#ccd6f6' }}>{p.title}</Card.Title>
                                        <Card.Text style={{ color: '#a8b2d1' }}>{p.description} </Card.Text>
                                        <div >
                                            <p className='tech-name'>{p.techStack[0]}</p>
                                            <p className='tech-name'>{p.techStack[1]}</p>
                                            <p className='tech-name'>{p.techStack[2]}</p>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>

                        )
                    })
                }

            </div>
        </Container>


    );
};

export default HomeProjects;